import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { useAuth } from '../contexts/AuthContext';
import { Loader2, Link2, Shield } from 'lucide-react';

const DiscordIcon = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" {...props}>
    <path d="M20.3 4.37A19.8 19.8 0 0 0 15.5 3l-.24.5a18.3 18.3 0 0 1 4.3 1.4c-5-2.2-11-2.2-16.1 0A18.3 18.3 0 0 1 7.7 3.5L7.5 3a19.8 19.8 0 0 0-4.9 1.37C.4 8.77-.25 13.06.1 17.3a20 20 0 0 0 6 3c.5-.7.9-1.4 1.3-2.1a13 13 0 0 1-2-.96c.17-.12.34-.25.5-.38 3.9 1.84 8.1 1.84 12 0 .17.13.34.26.5.38a13 13 0 0 1-2 .96c.4.7.8 1.4 1.3 2.1a20 20 0 0 0 6-3c.4-4.94-.7-9.2-3.4-12.93ZM8.5 14.9c-1.2 0-2.2-1.1-2.2-2.4 0-1.3 1-2.4 2.2-2.4 1.2 0 2.2 1.1 2.2 2.4 0 1.3-1 2.4-2.2 2.4Zm7 0c-1.2 0-2.2-1.1-2.2-2.4 0-1.3 1-2.4 2.2-2.4 1.2 0 2.2 1.1 2.2 2.4 0 1.3-1 2.4-2.2 2.4Z"/>
  </svg>
);

export default function LoginDialog({ open, onOpenChange }) {
  const [loading, setLoading] = useState(false);
  const { loginDiscord } = useAuth();

  const go = async () => {
    setLoading(true);
    try { await loginDiscord(); } catch { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><DiscordIcon className="text-[#5865F2]" /> Discord ile Giriş</DialogTitle>
          <DialogDescription>
            Hesabınıza güvenli şekilde erişiyoruz — sadece Discord profilinizi ve sunucu rollerinizi okuyoruz.
          </DialogDescription>
        </DialogHeader>

        <div className="mt-4 space-y-3 text-sm" style={{ color: 'var(--text-muted)' }}>
          <div className="flex items-start gap-2"><Shield size={16} className="mt-0.5 text-emerald-500" /><span>Giriş sonrası wiki okuyabilir ve yorum yapabilirsiniz.</span></div>
          <div className="flex items-start gap-2"><Link2 size={16} className="mt-0.5 text-cyan-500" /><span>Yetkili bir üyeyseniz wiki yazıları oluşturabilir ve düzenleyebilirsiniz.</span></div>
        </div>

        <button onClick={go} disabled={loading} className="mt-5 w-full justify-center pill-btn font-semibold" style={{ background: '#5865F2', color: '#fff', borderColor: 'transparent' }}>
          {loading ? <Loader2 className="animate-spin" size={16} /> : <DiscordIcon />}
          <span>Discord ile Devam Et</span>
        </button>
      </DialogContent>
    </Dialog>
  );
}
